import * as React from 'react';
import { Typography, Button, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Table, TableRow, TableCell, TableBody } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrowOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import { Link } from 'react-router-dom';
import { ModuleSubmissionStatusEnum } from 'src/constants/Enum/ModuleEnum';

export default class CoverageComponent extends React.Component<any, any> {

    getCoverageSuccessPercentageStatus() {
        let coverageCompleted = false;
        if (this.props.data && this.props.data.categories) {
            for (const category of this.props.data.categories) {
                for (const module of category.modules) {
                    if (module.module_status === ModuleSubmissionStatusEnum.Completed) {
                        coverageCompleted = true;
                    }
                    else {
                        coverageCompleted = false;
                        break;
                    }
                }
            }
        }

        return coverageCompleted;
    }

    render() {
        const coverageCompleted = this.getCoverageSuccessPercentageStatus();

        return (
            <div className="media-content media-content-divided">
                <div className={coverageCompleted ? "media-left media-box media-box-success media-box-large" : "media-left media-box media-box-primary media-box-large"}>
                    {coverageCompleted ? <CheckIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
                </div>
                <div className="media-body">
                    <h5 className="mt-0">Coverage</h5>
                    <p>Collecting data for 2022 programme coverage</p>
                </div>
                <div className="media-content-acc-group">
                    <div className="">
                        {this.props.data && this.props.data.categories &&
                            this.props.data.categories.map((category: any, catIndex: any) => {
                                const moduleLength = category.modules.length;
                                return (
                                    <>
                                        {
                                            moduleLength > 0 ?
                                                <ExpansionPanel className="ExpansionPanel" key={catIndex}>
                                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className="ExpansionPanelSummary">
                                                        <div className={category && !category.is_all_modules_submitted ? "media-box media-box-primary media-box-small" : "media-box media-box-success media-box-small"}>
                                                            {category && !category.is_all_modules_submitted ? <PlayArrowIcon fontSize="large" /> : <CheckIcon fontSize="large" />}
                                                        </div>

                                                        <div className="media-heading">
                                                            <Typography className="">{category.category_name}</Typography>
                                                        </div>

                                                        <div className="progress">
                                                            <div className={category && !category.is_all_modules_submitted ? "progress-bar progress-bar-primary" : "progress-bar progress-bar-success"} style={{ width: category.percentage_completed + '%' }} role="progressbar">
                                                                &nbsp;
                                                            </div>
                                                        </div>
                                                    </ExpansionPanelSummary>

                                                    <ExpansionPanelDetails className="ExpansionPanelDetails" key={"category_" + catIndex}>
                                                        <Table className="">
                                                            <TableBody>
                                                                {
                                                                    category.modules.map((module: any, modIndex: any) => {
                                                                        return (
                                                                            <>
                                                                                {
                                                                                    module.is_enabled ?
                                                                                        <TableRow key={modIndex}>
                                                                                            <TableCell className="width10">
                                                                                                <div className={module.module_status !== ModuleSubmissionStatusEnum.Completed ? "media-box media-box-primary media-box-small" : "media-box media-box-success media-box-small"}>
                                                                                                    <b> {module.module_status !== ModuleSubmissionStatusEnum.Completed ? <PlayArrowIcon /> : <CheckIcon className="media-box-success" />} </b>
                                                                                                </div>
                                                                                            </TableCell>
                                                                                            <TableCell > <b>{module.module_name}</b> </TableCell>
                                                                                            <TableCell> <b> {module.percentage_completed}</b> </TableCell>
                                                                                            <TableCell>
                                                                                                <div className="surveyRedirect">
                                                                                                    <Link to={`/survey/response/${module.country_module_survey_mapping_id}`}>
                                                                                                        <Button type="button" className="btn-blue-primary" variant="outlined" size="small">
                                                                                                            <ArrowForwardIcon />
                                                                                                        </Button>
                                                                                                    </Link>
                                                                                                </div>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        :
                                                                                        <TableRow className="media-module-disable" key={modIndex}>
                                                                                            <TableCell className="width10"> <div className="media-na"><b>NA</b></div> </TableCell>
                                                                                            <TableCell > <b>{module.module_name}</b> </TableCell>
                                                                                            <TableCell > {module.percentage_completed} </TableCell>
                                                                                            <TableCell > &nbsp; </TableCell>
                                                                                        </TableRow>
                                                                                }
                                                                            </>
                                                                        );
                                                                    })
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                                : ''
                                        }
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/surveys/dashboard/Coverage.tsx